var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeniwave = function SvgSeniwave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    d: "M12.958 0C10.364 0 6.7 3.994 4.737 8.943H1.174C-.777 13.944-.241 18 2.372 18s6.257-3.994 8.22-8.943h3.562C16.107 4.054 15.57 0 12.957 0M42.276 0c-2.54 0-6.105 3.829-8.095 8.634C35.94 3.83 35.363 0 32.824 0s-6.063 3.784-8.06 8.55C26.486 3.785 25.9 0 23.375 0s-6.313 4.054-8.266 9.057h5.261C18.47 14.007 19.018 18 21.612 18s6.105-3.828 8.095-8.634C27.947 14.172 28.525 18 31.064 18s6.257-3.994 8.22-8.943h4.19C45.427 4.054 44.89 0 42.276 0"
  })));
};
export default SvgSeniwave;